import { AnimatePresence, motion } from "framer-motion";
import {
  ArrowLeft,
  ArrowRight,
  Calendar,
  Check,
  Mail,
  Phone,
  Search,
  Sparkles,
  Star,
} from "lucide-react";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "../components/ui/carousel";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../components/ui/dialog";
import { ScrollArea } from "../components/ui/scroll-area";

import EmailGate from "../components/EmailGate";
import {
  buildContentTrackingMetadata,
  getStoredContentSessionId,
} from "../lib/gatedContentTracking";
import AgentTitleSlide from "../components/backup/slides/AgentTitleSlide";
import AIReceptionistSlide from "../components/backup/slides/AIReceptionistSlide";
import AlainaSlide from "../components/backup/slides/AlainaSlide";
import DenialManagementSlide from "../components/backup/slides/DenialManagementSlide";
import ArielSlide from "../components/backup/slides/ArielSlide";
import AshaVsDentinaReceptionistSlide from "../components/backup/slides/AshaVsDentinaReceptionistSlide";
import AshaVsDentinaSlide from "../components/backup/slides/AshaVsDentinaSlide";
import AshaVsWeaveSlide from "../components/backup/slides/AshaVsWeaveSlide";
import BackingSlide from "../components/backup/slides/BackingSlide";
import AshaVsEassistSlide from "../components/backup/slides/AshaVsEassistSlide";
import PMSPricingComparisonSlide from "../components/backup/slides/PMSPricingComparisonSlide";
import AshaOperatingSystemSlide from "../components/backup/slides/AshaOperatingSystemSlide";
import AshaBasicallyFreeSlide from "../components/backup/slides/AshaBasicallyFreeSlide";
import PriceMatchGuaranteeSlide from "../components/backup/slides/PriceMatchGuaranteeSlide";
import TotalPricingComparisonSlide from "../components/backup/slides/TotalPricingComparisonSlide";
import BenefitFormsSlide from "../components/backup/slides/BenefitFormsSlide";
import CaseStudySlide from "../components/backup/slides/CaseStudySlide";
import CommunicationSuiteSlide from "../components/backup/slides/CommunicationSuiteSlide";
import MarketingTitleSlide from "../components/backup/slides/MarketingTitleSlide";
import SMSCampaignsSlide from "../components/backup/slides/SMSCampaignsSlide";
import EmailCampaignsSlide from "../components/backup/slides/EmailCampaignsSlide";
import CommunicationTitleSlide from "../components/backup/slides/CommunicationTitleSlide";
import ComparisonsTitleSlide from "../components/backup/slides/ComparisonsTitleSlide";
import AshaVsLassieSlide from "../components/backup/slides/AshaVsLassieSlide";
import CompetitorAnalysisSlide from "../components/backup/slides/CompetitorAnalysisSlide";
import CommunicationSuiteComparisonSlide from "../components/backup/slides/CommunicationSuiteComparisonSlide";
import ComprehensiveBreakdownsSlide from "../components/backup/slides/ComprehensiveBreakdownsSlide";
import EFAXSlide from "../components/backup/slides/EFAXSlide";
import ElisePatientExperienceSlide from "../components/backup/slides/ElisePatientExperienceSlide";
import MorganPatientIntakeSlide from "../components/backup/slides/MorganPatientIntakeSlide";
import PracticeManagerSlide from "../components/backup/slides/PracticeManagerSlide";
import FrontOfficeGettingStartedSlide from "../components/backup/slides/FrontOfficeGettingStartedSlide";
import OnboardingTimelineSlide from "../components/backup/slides/OnboardingTimelineSlide";
import GettingStartedSlide from "../components/backup/slides/GettingStartedSlide";
import ContractTermsSlide from "../components/backup/slides/ContractTermsSlide";
import WhiteGloveOnboardingSlide from "../components/backup/slides/WhiteGloveOnboardingSlide";
import GoLiveTimelineSlide from "../components/backup/slides/GoLiveTimelineSlide";
import DataMigrationSlide from "../components/backup/slides/DataMigrationSlide";
import FAQSlide from "../components/backup/slides/FAQSlide";
import ConsolidationSlide from "../components/backup/slides/ConsolidationSlide";
import ManualTasksSlide from "../components/backup/slides/ManualTasksSlide";
import RevenueLeakageSlide from "../components/backup/slides/RevenueLeakageSlide";
import BandwidthProblemSlide from "../components/backup/slides/BandwidthProblemSlide";
import HygieneRecallSlide from "../components/backup/slides/HygieneRecallSlide";
import InsuranceCallingSlide from "../components/backup/slides/InsuranceCallingSlide";
import InsuranceCopilotSlide from "../components/backup/slides/InsuranceCopilotSlide";
import InsuranceVerificationSlide from "../components/backup/slides/InsuranceVerificationSlide";
import IntelligentSchedulingSlide from "../components/backup/slides/IntelligentSchedulingSlide";
import KimCaseAcceptanceSlide from "../components/backup/slides/KimCaseAcceptanceSlide";
import LenaSlide from "../components/backup/slides/LenaSlide";
import LenaWorkflowSlide from "../components/backup/slides/LenaWorkflowSlide";
import NextGenFormsSlide from "../components/backup/slides/NextGenFormsSlide";
import RealROISlide from "../components/backup/slides/RealROISlide";
import ROIIntroSlide from "../components/backup/slides/ROIIntroSlide";
import VoIPSlide from "../components/backup/slides/VoIPSlide";
import PhysicalPhonesSlide from "../components/backup/slides/PhysicalPhonesSlide";
import TextToPaySlide from "../components/backup/slides/TextToPaySlide";
import CardReadersSlide from "../components/backup/slides/CardReadersSlide";
import TeamChatSlide from "../components/backup/slides/TeamChatSlide";
import OnlineSchedulingSlide from "../components/backup/slides/OnlineSchedulingSlide";
import PMSSchedulingSlide from "../components/backup/slides/PMSSchedulingSlide";
import PMSChartingSlideAnimated from "../components/backup/slides/PMSChartingSlideAnimated";
import PMSTreatmentPlanningSlide from "../components/backup/slides/PMSTreatmentPlanningSlide";
import PMSClinicalNotesSlide from "../components/backup/slides/PMSClinicalNotesSlide";
import PMSFileManagementSlide from "../components/backup/slides/PMSFileManagementSlide";
import PMSImagingSlide from "../components/backup/slides/PMSImagingSlide";
import PMSAITreatmentPlannerSlide from "../components/backup/slides/PMSAITreatmentPlannerSlide";
import PMSRevenueAnalyticsSlide from "../components/backup/slides/PMSRevenueAnalyticsSlide";
import PMSAIScribeSlide from "../components/backup/slides/PMSAIScribeSlide";
import PMSAshaCopilotSlide from "../components/backup/slides/PMSAshaCopilotSlide";

import EOBProcessingSlide from "../components/backup/slides/EOBProcessingSlide";
import EOBStreamliningSlide from "../components/backup/slides/EOBStreamliningSlide";
import PatientBillingSlide from "../components/backup/slides/PatientBillingSlide";
import PaymentReconciliationSlide from "../components/backup/slides/PaymentReconciliationSlide";

import PMSOfferingsSlide from "../components/backup/slides/PMSOfferingsSlide";
import PMSDemoSlide from "../components/backup/slides/PMSDemoSlide";
import PMSTeamIntro1Slide from "../components/backup/slides/PMSTeamIntro1Slide";
import PMSTeamIntro2Slide from "../components/backup/slides/PMSTeamIntro2Slide";
import AIWorkforceSlide from "../components/backup/slides/AIWorkforceSlide";
import PlatformAndAIWorkforceSlide from "../components/backup/slides/PlatformAndAIWorkforceSlide";
import AIROISlide from "../components/backup/slides/AIROISlide";
import AIClinicSlide from "../components/backup/slides/AIClinicSlide";
import AshaCortexSlide from "../components/backup/slides/AshaCortexSlide";
import AriaAutopilotSlide from "../components/backup/slides/AriaAutopilotSlide";
import OverviewTestimonialsSlide from "../components/backup/slides/OverviewTestimonialsSlide";
import agentDemoScenarios from "../components/agentDemoScenarios";

// NEW OS-specific slides
import AIFunctionsSlide from "../components/backup/slides/AIFunctionsSlide";
import AIFunctionsValueSlide from "../components/backup/slides/AIFunctionsValueSlide";
import SoftwareStackCostSlide from "../components/backup/slides/SoftwareStackCostSlide";
import RCMPricingComparisonSlide from "../components/backup/slides/RCMPricingComparisonSlide";
import EngagementModelsV3Slide from "../components/backup/slides/EngagementModelsV3Slide";
import PricingComparisonV3Slide from "../components/backup/slides/PricingComparisonV3Slide";
import FlexiblePlanSlide from "../components/backup/slides/FlexiblePlanSlide";
import AIOSEmphasisSlide from "../components/backup/slides/AIOSEmphasisSlide";
import HowCanWeHelpSlide from "../components/backup/slides/HowCanWeHelpSlide";
import TotalCostCalculatorSlide from "../components/backup/slides/TotalCostCalculatorSlide";
import ROICalculatorSlide from "../components/backup/slides/ROICalculatorSlide";
import FellowsIntroSlide from "../components/backup/slides/FellowsIntroSlide";
import FellowsThoughtLeadershipSlide from "../components/backup/slides/FellowsThoughtLeadershipSlide";
import FellowsAgentBuilderSlide from "../components/backup/slides/FellowsAgentBuilderSlide";
import FellowsPartnerPerksSlide from "../components/backup/slides/FellowsPartnerPerksSlide";
import AICreditFAQSlide from "../components/backup/slides/AICreditFAQSlide";

const osSlides = [
  { id: 0, slug: "welcome", title: "Welcome", indent: 0 },
  { id: 1, slug: "why-asha", title: "Why Asha?", indent: 0 },
  { id: 2, slug: "backing", title: "Backing & Team", indent: 0 },
  // Overview
  { id: 300, slug: "overview", title: "Overview", indent: 0 },
  { id: 157, slug: "consolidation", title: "What Your Software Handles Today", indent: 1 },
  { id: 158, slug: "manual-tasks", title: "What Your Staff Handles Today", indent: 1 },
  { id: 309, slug: "bandwidth-problem", title: "Humans Have Limited Bandwidth", indent: 1 },
  { id: 159, slug: "revenue-leakage", title: "The Cost of Doing Nothing", indent: 1 },
  { id: 310, slug: "how-can-we-help", title: "So How Can We Help?", indent: 1 },
  { id: 305, slug: "ai-clinic", title: "10 Softwares + 20 AI Products in 1 Platform", indent: 1 },
  { id: 306, slug: "aria", title: "ARIA", indent: 1 },
  { id: 99, slug: "offerings", title: "AI-Native PMS", indent: 1 },
  { id: 304, slug: "ai-workforce", title: "The Asha Transformation", indent: 1 },
  { id: 308, slug: "overview-testimonials", title: "What Dentists Have to Say About ASHA", indent: 1 },
  // PMS Features
  { id: 400, slug: "pms-features", title: "PMS Features", indent: 0 },
  { id: 401, slug: "pms-scheduling", title: "Smart Scheduling", indent: 1 },
  { id: 402, slug: "pms-charting", title: "Clinical Charting", indent: 1 },
  { id: 404, slug: "pms-clinical-notes", title: "Clinical Notes", indent: 1 },
  { id: 405, slug: "pms-file-management", title: "Document Management", indent: 1 },
  { id: 406, slug: "pms-imaging", title: "Digital Imaging", indent: 1 },
  { id: 407, slug: "pms-ai-treatment-planner", title: "AI Treatment Planner", indent: 1 },
  { id: 408, slug: "pms-revenue-analytics", title: "AI Revenue Analytics Suite", indent: 1 },
  { id: 409, slug: "pms-ai-scribe", title: "AI Scribe", indent: 1 },
  { id: 410, slug: "pms-asha-copilot", title: "Asha Copilot", indent: 1 },
  // Front Office AI Team
  { id: 3, slug: "ai-team-1", title: "Front Office AI Team", indent: 0 },
  { id: 4, slug: "amy", title: "Amy, Receptionist", indent: 1 },
  { id: 5, slug: "amy-features", title: "Features", indent: 2 },
  { id: 6, slug: "amy-scheduling", title: "Intelligent Scheduling", indent: 2 },
  { id: 7, slug: "leena", title: "Leena, Schedule Optimizer", indent: 1 },
  { id: 8, slug: "leena-features", title: "Features", indent: 2 },
  { id: 9, slug: "leena-workflow", title: "12-Step Workflow", indent: 2 },
  { id: 10, slug: "stephanie", title: "Stephanie, Hygiene Recall", indent: 1 },
  { id: 11, slug: "stephanie-features", title: "Features", indent: 2 },
  { id: 110, slug: "kim", title: "Kim, Case Acceptance", indent: 1 },
  { id: 111, slug: "kim-revenue", title: "Revenue Automation", indent: 2 },
  { id: 112, slug: "elise", title: "Elise, Patient Experience", indent: 1 },
  { id: 113, slug: "elise-reviews", title: "Review Generation", indent: 2 },
  { id: 114, slug: "morgan", title: "Morgan, Patient Intake", indent: 1 },
  { id: 115, slug: "morgan-intake", title: "Intake & Insurance", indent: 2 },
  { id: 116, slug: "practice-manager", title: "Trisha, Practice Manager", indent: 1 },
  { id: 117, slug: "practice-manager-dashboard", title: "Task Dashboard", indent: 2 },
  // Communication Suite
  { id: 17, slug: "comms-suite", title: "Communication Suite", indent: 0 },
  { id: 18, slug: "voip", title: "VoIP", indent: 1 },
  { id: 29, slug: "forms", title: "Next-Gen Forms", indent: 1 },
  { id: 19, slug: "messaging", title: "2-Way Messaging", indent: 1 },
  { id: 20, slug: "fax", title: "Intelligent Fax", indent: 1 },
  { id: 201, slug: "sms-campaigns", title: "SMS Campaigns", indent: 1 },
  { id: 202, slug: "email-campaigns", title: "Email Campaigns", indent: 1 },
  { id: 2041, slug: "physical-phones", title: "Physical Phones", indent: 1 },
  { id: 2051, slug: "text-to-pay", title: "Text-to-Pay", indent: 1 },
  { id: 206, slug: "card-readers", title: "Card Readers", indent: 1 },
  { id: 207, slug: "team-chat", title: "Team Chat", indent: 1 },
  { id: 208, slug: "online-scheduling", title: "Online Scheduling", indent: 1 },
  // Revenue Cycle AI Team
  { id: 22, slug: "ai-team-2", title: "Revenue Cycle AI Team", indent: 0 },
  { id: 12, slug: "amanda", title: "Amanda, Insurance Verification", indent: 1 },
  { id: 13, slug: "amanda-checks", title: "Automatic Checks", indent: 2 },
  { id: 30, slug: "amanda-breakdowns", title: "Comprehensive Breakdowns", indent: 2 },
  { id: 31, slug: "amanda-copilot", title: "AI Insurance Co-Pilot", indent: 2 },
  { id: 16, slug: "amanda-forms", title: "Automated Forms", indent: 2 },
  { id: 15, slug: "amanda-calling", title: "AI Calling", indent: 2 },
  { id: 23, slug: "ariel", title: "Ariel, Claims Expert", indent: 1 },
  { id: 24, slug: "ariel-submission", title: "Claim Submission", indent: 2 },
  { id: 101, slug: "ariel-scrubbing", title: "Claim Scrubbing", indent: 2 },
  { id: 100, slug: "alisha", title: "Alisha, EOB Posting", indent: 1 },
  { id: 25, slug: "alisha-posting", title: "Automated Posting", indent: 2 },
  { id: 102, slug: "alisha-reconciliation", title: "Payment Reconciliation", indent: 2 },
  { id: 103, slug: "alisha-ingestion", title: "Unified Ingestion", indent: 2 },
  { id: 26, slug: "kianna", title: "Kianna, Patient Billing", indent: 1 },
  { id: 104, slug: "kianna-campaigns", title: "Voice Campaigns", indent: 2 },
  { id: 700, slug: "sarah", title: "Sarah, Denial Management", indent: 1 },
  { id: 701, slug: "sarah-denial-analysis", title: "AI Denial Analysis", indent: 2 },
  // Pricing & Packaging
  { id: 150, slug: "pricing", title: "Pricing & Packaging", indent: 0 },
  { id: 203, slug: "asha-operating-system", title: "Asha AI Operating System", indent: 1 },
  { id: 607, slug: "total-cost-calculator", title: "Total Cost to Piecemeal", indent: 1 },
  { id: 603, slug: "engagement-models", title: "Pricing", indent: 1 },
  { id: 604, slug: "pricing-comparison", title: "Pricing Perspective", indent: 1 },
  { id: 608, slug: "roi-calculator", title: "ROI Calculator", indent: 1 },
  { id: 2042, slug: "asha-basically-free", title: "Asha Pays for Itself", indent: 1 },
  // AI Innovation Fellows
  { id: 900, slug: "fellows", title: "AI Innovation Fellows", indent: 0 },
  { id: 901, slug: "fellows-intro", title: "The Program", indent: 1 },
  { id: 904, slug: "fellows-partner-perks", title: "Partner Perks", indent: 1 },
  // Getting Started
  { id: 210, slug: "getting-started", title: "Getting Started", indent: 0 },
  { id: 211, slug: "go-live-timeline", title: "4-Week Go-Live", indent: 1 },
  { id: 156, slug: "data-migration", title: "Seamless Data Migration", indent: 1 },
  { id: 155, slug: "contract-terms", title: "Contract Terms", indent: 1 },
  { id: 109, slug: "white-glove-onboarding", title: "Onboarding & Strategy Advisory", indent: 1 },
  // FAQ
  { id: 215, slug: "faq", title: "FAQ", indent: 0 },
  { id: 216, slug: "frequently-asked-questions", title: "Frequently Asked Questions", indent: 1 },
  { id: 217, slug: "ai-credits", title: "AI Credit Utilization", indent: 1 },
  // ROI & Impact
  { id: 120, slug: "roi", title: "ROI & Impact", indent: 0 },
  { id: 500, slug: "case-study-dental-art-care", title: "Dental Art Care Case Study", indent: 1 },
  { id: 510, slug: "case-study-generational", title: "Generational Dental Case Study", indent: 1 },
  { id: 511, slug: "case-study-marquette", title: "Marquette Dentistry Case Study", indent: 1 },
  { id: 501, slug: "case-study-clovis", title: "Clovis Family Case Study", indent: 1 },
  { id: 502, slug: "case-study-dds-spokane", title: "DDS Spokane Case Study", indent: 1 },
  { id: 503, slug: "case-study-st-charles", title: "St. Charles Case Study", indent: 1 },
  { id: 504, slug: "case-study-premier", title: "Premier Dentistry Case Study", indent: 1 },
  { id: 505, slug: "case-study-hudson-valley", title: "Dental Arts of Hudson Valley", indent: 1 },
  { id: 122, slug: "case-study-ntx", title: "NTX Mental Health Case Study", indent: 1 },
  { id: 123, slug: "roi-data", title: "Real Practice Data", indent: 1 },
];

const OSV3SlideshowBackupPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [scale, setScale] = useState(1);
  const [isLocked, setIsLocked] = useState(true);
  const containerRef = React.useRef(null);
  const slideStartTimeRef = React.useRef(Date.now());
  const currentSlideRef = React.useRef(0);

  const recordSlideView = (slideIndex, duration, useBeacon = false) => {
    const sessionId = getStoredContentSessionId("asha_os_slideshow_session_id");
    if (!sessionId || duration < 1000) return;

    const slide = osSlides[slideIndex];
    const payload = JSON.stringify({
      sessionId,
      slideId: slide?.id ?? slideIndex,
      slideTitle: slide?.title ?? `Slide ${slideIndex}`,
      slideSlug: slide?.slug,
      durationSeconds: Math.round(duration / 1000),
      ...buildContentTrackingMetadata({ contentType: "slideshow" }),
    });

    const isLocalhost =
      typeof window !== "undefined" &&
      (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1");
    const apiUrl =
      process.env.REACT_APP_API_URL ||
      (isLocalhost ? "http://localhost:8001" : "");
    const url = `${apiUrl}/api/slideshow/slide-view`;

    if (useBeacon && typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" });
      navigator.sendBeacon(url, blob);
      return;
    }

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch((err) => console.error("Failed to record slide view", err));
  };

  useEffect(() => {
    const hasAccess = localStorage.getItem("asha_os_slideshow_access");
    const sessionId = getStoredContentSessionId("asha_os_slideshow_session_id");
    if (hasAccess && sessionId) {
      setIsLocked(false);
    }
  }, []);

  const handleAccessGranted = (email) => {
    localStorage.setItem("asha_os_slideshow_access", "true");
    console.log("Access granted for:", email);
    currentSlideRef.current = api?.selectedScrollSnap?.() ?? 0;
    slideStartTimeRef.current = Date.now();
    setIsLocked(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const parentWidth = containerRef.current.offsetWidth;
        const targetWidth = 1400;
        const newScale = parentWidth / targetWidth;
        setScale(newScale);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!api) {
      return;
    }

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on("select", () => {
      const newIndex = api.selectedScrollSnap();

      const now = Date.now();
      const duration = now - slideStartTimeRef.current;

      recordSlideView(currentSlideRef.current, duration);

      currentSlideRef.current = newIndex;
      slideStartTimeRef.current = now;

      setCurrent(newIndex + 1);

      const slideSlug = osSlides[newIndex]?.slug;
      if (slideSlug) {
        setSearchParams({ slide: slideSlug }, { replace: true });
      }
    });

    return () => {
      const now = Date.now();
      const duration = now - slideStartTimeRef.current;
      recordSlideView(currentSlideRef.current, duration);
    };
  }, [api, setSearchParams]);

  useEffect(() => {
    const flushOnHide = () => {
      const now = Date.now();
      const duration = now - slideStartTimeRef.current;
      recordSlideView(currentSlideRef.current, duration, true);
      slideStartTimeRef.current = now;
    };
    window.addEventListener("pagehide", flushOnHide);
    return () => window.removeEventListener("pagehide", flushOnHide);
  }, []);

  useEffect(() => {
    if (!api) return;

    const handleKeyDown = (event) => {
      if (event.key === "ArrowRight") {
        api.scrollNext();
      } else if (event.key === "ArrowLeft") {
        api.scrollPrev();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [api]);

  useEffect(() => {
    if (!api) return;

    const slideParam = searchParams.get("slide");
    if (slideParam) {
      let slideIndex = osSlides.findIndex((s) => s.slug === slideParam);

      if (slideIndex === -1) {
        const slideId = parseInt(slideParam, 10);
        if (!isNaN(slideId)) {
          slideIndex = osSlides.findIndex((s) => s.id === slideId);
        }
      }

      if (slideIndex !== -1) {
        setTimeout(() => {
          api.scrollTo(slideIndex);
        }, 100);
      }
    }
  }, [api, searchParams]);

  const filteredSlides = osSlides
    .map((slide, index) => ({ ...slide, originalIndex: index }))
    .filter((slide) =>
      slide.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

  return (
    <div className="min-h-screen xl:h-screen w-screen bg-neutral-900 flex flex-col items-center justify-start p-2 md:p-8 pt-4 xl:pt-4 overflow-y-auto xl:overflow-hidden overflow-x-hidden relative">
      <AnimatePresence>
        {isLocked && <EmailGate onAccessGranted={handleAccessGranted} sessionStorageKey="asha_os_slideshow_session_id" />}
      </AnimatePresence>

      {/* Top Actions */}
      <div className="w-full max-w-[1800px] flex justify-between items-center gap-3 mb-4 z-50">
        <div className="relative group px-1 w-[260px]">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30 group-focus-within:text-blue-400 transition-colors" />
          <input
            type="text"
            placeholder="Search slides..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-white/5 border border-white/10 rounded-xl py-2.5 pl-10 pr-4 text-sm text-white placeholder:text-white/20 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500/50 transition-all shadow-inner"
          />
        </div>

        <div className="flex items-center gap-3">
          <Dialog>
            <DialogTrigger asChild>
              <Button
                variant="outline"
                className="bg-white/5 backdrop-blur-sm border-white/10 text-white hover:bg-white/10 hover:text-white"
              >
                I have questions
              </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-md bg-white border-0 shadow-2xl rounded-2xl p-0 overflow-hidden">
              <DialogHeader className="p-6 pb-2">
                <DialogTitle className="text-2xl font-bold text-slate-900 tracking-tight">
                  Get in Touch
                </DialogTitle>
                <DialogDescription className="text-slate-500 text-base">
                  Have questions about Asha? We're here to help.
                </DialogDescription>
              </DialogHeader>
              <div className="flex flex-col gap-3 p-6 pt-2">
                <Button
                  variant="outline"
                  className="w-full justify-start gap-4 h-auto py-4 px-4 text-left border-slate-200 hover:border-blue-300 hover:bg-blue-50/30 hover:shadow-md transition-all duration-200 group bg-white rounded-xl shadow-sm"
                  onClick={() =>
                    window.open(
                      "https://calendly.com/asha-health/dental-one-stop-shop",
                      "_blank"
                    )
                  }
                >
                  <div className="w-12 h-12 rounded-2xl bg-blue-100 flex items-center justify-center text-blue-600 shrink-0 group-hover:scale-105 transition-transform duration-200 shadow-sm border border-blue-200">
                    <Calendar className="w-6 h-6" />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <span className="font-semibold text-slate-900 text-base group-hover:text-blue-700 transition-colors">
                      Book a meeting
                    </span>
                    <span className="text-sm text-slate-500">
                      Schedule time with our team
                    </span>
                  </div>
                </Button>

                <Button
                  variant="outline"
                  className="w-full justify-start gap-4 h-auto py-4 px-4 text-left border-slate-200 hover:border-green-300 hover:bg-green-50/30 hover:shadow-md transition-all duration-200 group bg-white rounded-xl shadow-sm"
                  onClick={() => (window.location.href = "sms:+19146779846")}
                >
                  <div className="w-12 h-12 rounded-2xl bg-green-100 flex items-center justify-center text-green-600 shrink-0 group-hover:scale-105 transition-transform duration-200 shadow-sm border border-green-200">
                    <Phone className="w-6 h-6" />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <span className="font-semibold text-slate-900 text-base group-hover:text-green-700 transition-colors">
                      Text us
                    </span>
                    <span className="text-sm font-bold text-slate-700">
                      (914) 677-9846
                    </span>
                  </div>
                </Button>

                <Button
                  variant="outline"
                  className="w-full justify-start gap-4 h-auto py-4 px-4 text-left border-slate-200 hover:border-purple-300 hover:bg-purple-50/30 hover:shadow-md transition-all duration-200 group bg-white rounded-xl shadow-sm"
                  onClick={() =>
                    (window.location.href = "mailto:onboarding@asha.health")
                  }
                >
                  <div className="w-12 h-12 rounded-2xl bg-purple-100 flex items-center justify-center text-purple-600 shrink-0 group-hover:scale-105 transition-transform duration-200 shadow-sm border border-purple-200">
                    <Mail className="w-6 h-6" />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <span className="font-semibold text-slate-900 text-base group-hover:text-purple-700 transition-colors">
                      Email us
                    </span>
                    <span className="text-sm font-bold text-slate-700">
                      onboarding@asha.health
                    </span>
                  </div>
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>

      <div className="w-full max-w-[1800px] flex flex-col xl:flex-row gap-6 items-center justify-center flex-1 min-h-0">
        {/* Table of Contents */}
        <div className="w-full xl:w-[260px] flex flex-col flex-1 xl:flex-none xl:h-full py-4 xl:pt-0 xl:pb-8 pr-0 xl:pr-2 order-2 xl:order-1 min-h-[300px]">
          <ScrollArea className="flex-1 -mr-2 pr-4 custom-scrollbar">
            <div className="pl-4 border-l border-white/10 space-y-2 py-2">
              {filteredSlides.map((slide) => (
                <button
                  key={`${slide.id}-${slide.slug}`}
                  onClick={() => api?.scrollTo(slide.originalIndex)}
                  className={`group flex items-center gap-3 w-full text-left transition-all duration-300 relative py-1.5 ${
                    current === slide.originalIndex + 1
                      ? "opacity-100"
                      : "opacity-40 hover:opacity-80"
                  }`}
                  style={{ paddingLeft: `${(slide.indent || 0) * 16}px` }}
                >
                  <div
                    className={`absolute -left-[17px] h-full w-[3px] rounded-full transition-all duration-500 ${
                      current === slide.originalIndex + 1
                        ? "bg-blue-500 opacity-100 shadow-[0_0_10px_rgba(59,130,246,0.5)]"
                        : "bg-transparent opacity-0"
                    }`}
                  />

                  <span
                    className={`text-sm font-medium tracking-wide transition-all duration-300 truncate ${
                      current === slide.originalIndex + 1
                        ? "text-blue-400 translate-x-1"
                        : "text-white"
                    }`}
                  >
                    {slide.title}
                  </span>
                </button>
              ))}
              {filteredSlides.length === 0 && (
                <div className="text-white/30 text-sm italic py-4">
                  No slides found
                </div>
              )}
            </div>
          </ScrollArea>
        </div>

        {/* Main Slide Container */}
        <div className="w-full xl:flex-1 max-w-[1400px] aspect-video relative order-1 xl:order-2 flex-shrink-0 group">
          <div
            ref={containerRef}
            className="w-full h-full overflow-hidden bg-transparent relative"
          >
            <div
              style={{
                width: "1400px",
                height: "787.5px",
                transform: `scale(${scale})`,
                transformOrigin: "top left",
                position: "absolute",
                top: 0,
                left: 0,
              }}
            >
              <Carousel setApi={setApi} className="w-full h-full">
                <div className="w-full h-full bg-white rounded-3xl overflow-hidden shadow-2xl ring-1 ring-white/10 relative isolate transform-gpu">
                  <CarouselContent className="h-full ml-0">
                    {/* SLIDE 1: HERO */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-gradient-to-br from-blue-600 to-indigo-600 flex flex-col items-center justify-center text-white px-4 relative overflow-hidden">
                        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff15_1px,transparent_1px),linear-gradient(to_bottom,#ffffff15_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)]" />

                        {[...Array(8)].map((_, i) => (
                          <motion.div
                            key={i}
                            className="absolute w-1.5 h-1.5 bg-blue-200 rounded-full blur-[1px]"
                            initial={{
                              x: Math.random() * 1000,
                              y: Math.random() * 600,
                              opacity: 0,
                            }}
                            animate={{
                              y: [null, Math.random() * -100],
                              opacity: [0, 0.6, 0],
                            }}
                            transition={{
                              duration: Math.random() * 4 + 3,
                              repeat: Infinity,
                              delay: Math.random() * 2,
                            }}
                            style={{
                              left: `${Math.random() * 100}%`,
                              top: `${Math.random() * 100}%`,
                            }}
                          />
                        ))}

                        <motion.div
                          animate={{
                            y: [0, -30, 0],
                            scale: [1, 1.1, 1],
                            opacity: [0.3, 0.5, 0.3],
                          }}
                          transition={{
                            duration: 8,
                            repeat: Infinity,
                            ease: "easeInOut",
                          }}
                          className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-blue-400 rounded-full blur-[120px] opacity-30 mix-blend-overlay"
                        />
                        <motion.div
                          animate={{
                            y: [0, 40, 0],
                            scale: [1, 1.2, 1],
                            opacity: [0.3, 0.6, 0.3],
                          }}
                          transition={{
                            duration: 10,
                            repeat: Infinity,
                            ease: "easeInOut",
                            delay: 1,
                          }}
                          className="absolute bottom-[-10%] right-[-10%] w-[600px] h-[600px] bg-indigo-400 rounded-full blur-[140px] opacity-30 mix-blend-overlay"
                        />

                        <motion.div
                          initial={{ opacity: 0, y: 30 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.8, ease: "easeOut" }}
                          className="text-center max-w-5xl z-10 relative"
                        >
                          <div className="mb-8 flex justify-center">
                            <div className="w-24 h-24 bg-white/10 backdrop-blur-md rounded-3xl flex items-center justify-center shadow-lg border border-white/20 relative group overflow-hidden p-4">
                              <img
                                src="/assets/alogo.png"
                                alt="Asha Logo"
                                className="w-full h-full object-contain relative z-10 drop-shadow-[0_0_10px_rgba(255,255,255,0.5)]"
                              />
                              <div className="absolute inset-0 bg-white/20 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500 opacity-0 group-hover:opacity-100" />
                            </div>
                          </div>

                          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-8 tracking-tighter drop-shadow-sm bg-clip-text text-transparent bg-gradient-to-b from-white via-white to-blue-200">
                            Asha Health
                          </h1>

                          <div className="relative inline-block mb-12">
                            <p className="text-lg md:text-xl lg:text-2xl font-light text-blue-50 max-w-4xl mx-auto leading-relaxed drop-shadow-sm">
                              The First{" "}
                              <span className="font-semibold text-white">
                                AI-Native Operating System
                              </span>{" "}
                              for Dental
                            </p>
                            <motion.div
                              initial={{ scaleX: 0 }}
                              animate={{ scaleX: 1 }}
                              transition={{ delay: 0.8, duration: 0.8 }}
                              className="absolute -bottom-2 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-blue-200 to-transparent opacity-50"
                            />
                          </div>

                          <div className="flex justify-center gap-6">
                            <Button
                              onClick={() => api?.scrollNext()}
                              size="lg"
                              className="bg-white text-blue-600 hover:bg-blue-50 font-bold text-lg px-10 py-7 rounded-full shadow-[0_0_20px_rgba(255,255,255,0.3)] hover:shadow-[0_0_30px_rgba(255,255,255,0.5)] transition-all transform hover:scale-105"
                            >
                              Start Tour <ArrowRight className="ml-2 h-5 w-5" />
                            </Button>
                          </div>
                        </motion.div>
                      </div>
                    </CarouselItem>

                    {/* SLIDE 2: WHY ASHA */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full flex flex-row">
                        <div className="w-1/2 bg-blue-600 text-white flex flex-col justify-center p-20 relative overflow-hidden">
                          <div className="absolute top-0 left-0 w-64 h-64 bg-blue-500 rounded-full blur-3xl opacity-20 -translate-x-1/2 -translate-y-1/2" />
                          <div className="relative z-10">
                            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-12 leading-tight">
                              Why do practices choose to work with Asha Health?
                            </h2>

                            <div className="space-y-10">
                              <motion.div
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.1 }}
                              >
                                <h3 className="text-xl lg:text-2xl font-semibold mb-3 flex items-start gap-4">
                                  <span className="flex-shrink-0 bg-white/20 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mt-1">
                                    1
                                  </span>
                                  <span>We're the only 1-stop shop.</span>
                                </h3>
                                <p className="text-blue-100 leading-relaxed pl-12 text-lg opacity-90">
                                  Not just an AI receptionist. A full team of
                                  front office + back office AI agents. No need
                                  for 10 different vendors for isolated point
                                  solutions that don't connect.
                                </p>
                              </motion.div>

                              <motion.div
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.3 }}
                              >
                                <h3 className="text-xl lg:text-2xl font-semibold mb-3 flex items-start gap-4">
                                  <span className="flex-shrink-0 bg-white/20 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mt-1">
                                    2
                                  </span>
                                  <span>Strongest backing in dental AI.</span>
                                </h3>
                                <p className="text-blue-100 leading-relaxed pl-12 text-lg opacity-90">
                                  Most amount of institutional capital raised,
                                  backed by Y-Combinator & General Catalyst.
                                  Built by Google AI product leaders & health
                                  system CMOs.
                                </p>
                              </motion.div>
                            </div>
                          </div>
                        </div>

                        <div className="w-1/2 bg-slate-100 relative h-full">
                          <img
                            src="/assets/doctorimage1.jpg"
                            alt="Dental Professional"
                            className="w-full h-full object-cover object-center"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent flex items-end p-12">
                            <div className="text-white">
                              <p className="font-medium text-xl mb-2">
                                Trusted by top practices
                              </p>
                              <div className="flex gap-1">
                                {[1, 2, 3, 4, 5].map((i) => (
                                  <Star
                                    key={i}
                                    className="fill-yellow-400 text-yellow-400 w-6 h-6"
                                  />
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CarouselItem>

                    {/* SLIDE 3: BACKING */}
                    <CarouselItem className="h-full pl-0">
                      <BackingSlide />
                    </CarouselItem>

                    {/* OVERVIEW SECTION TITLE */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-slate-900 flex flex-col items-center justify-center text-white p-8">
                        <div className="text-center space-y-6 max-w-4xl">
                           <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-blue-500/10 text-blue-500 mb-4 border border-blue-500/20">
                             <Sparkles className="w-10 h-10" />
                           </div>
                           <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
                             <span className="text-blue-400">Overview</span>
                           </h1>
                           <p className="text-xl md:text-2xl text-slate-400 max-w-2xl mx-auto">
                             Understanding the current state of practice operations
                           </p>
                        </div>
                      </div>
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <ConsolidationSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <ManualTasksSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <BandwidthProblemSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <RevenueLeakageSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <HowCanWeHelpSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <AIOSEmphasisSlide onNavigate={(slug) => {
                        const idx = osSlides.findIndex(s => s.slug === slug);
                        if (idx !== -1) api?.scrollTo(idx);
                      }} />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <AshaCortexSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <PMSOfferingsSlide
                        onExplore={(type) => {
                          if (type === "front-office") {
                            const idx = osSlides.findIndex(s => s.slug === "ai-team-1");
                            if (idx !== -1) api?.scrollTo(idx);
                          } else if (type === "back-office") {
                            const idx = osSlides.findIndex(s => s.slug === "ai-team-2");
                            if (idx !== -1) api?.scrollTo(idx);
                          }
                        }}
                      />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <PlatformAndAIWorkforceSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0"><OverviewTestimonialsSlide /></CarouselItem>

                    {/* PMS FEATURES SECTION TITLE */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-slate-900 flex flex-col items-center justify-center text-white p-8">
                        <div className="text-center space-y-6 max-w-4xl">
                           <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-indigo-500/10 text-indigo-500 mb-4 border border-indigo-500/20">
                             <Sparkles className="w-10 h-10" />
                           </div>
                           <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
                             Core <span className="text-indigo-400">PMS Features</span>
                           </h1>
                           <p className="text-xl md:text-2xl text-slate-400 max-w-2xl mx-auto">
                             Everything you need to manage your dental practice
                           </p>
                        </div>
                      </div>
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0"><PMSSchedulingSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSChartingSlideAnimated /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSClinicalNotesSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSFileManagementSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSImagingSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSAITreatmentPlannerSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSRevenueAnalyticsSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSAIScribeSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSAshaCopilotSlide /></CarouselItem>

                    {/* FRONT OFFICE AI TEAM */}
                    <CarouselItem className="h-full pl-0">
                      <PMSTeamIntro1Slide
                        onAgentClick={(slug) => {
                          if (slug) {
                            const slideIndex = osSlides.findIndex((s) => s.slug === slug);
                            if (slideIndex !== -1) {
                              api?.scrollTo(slideIndex);
                            }
                          }
                        }}
                      />
                    </CarouselItem>

                    {/* AMY */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Amy" role="AI Dental Receptionist" image="/assets/amy.png" subtitle="Answers calls 24/7, and books patients directly into Asha PMS." demoScenario={agentDemoScenarios.amy} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><AIReceptionistSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><IntelligentSchedulingSlide /></CarouselItem>

                    {/* LEENA */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Leena" role="Schedule Optimizer" image="/assets/leena.png" subtitle="The intelligent agent who proactively keeps your chairs full and production high." demoScenario={agentDemoScenarios.leena} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><LenaSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><LenaWorkflowSlide /></CarouselItem>

                    {/* STEPHANIE */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Stephanie" role="Hygiene Recall Specialist" image="/assets/stephanie.png" subtitle="Runs intelligent AI voice campaigns to reactivate patients and fill your hygiene schedule." demoScenario={agentDemoScenarios.stephanie} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><HygieneRecallSlide /></CarouselItem>

                    {/* KIM */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Kim" role="Case Acceptance Specialist" image="/assets/kim.png" subtitle="Turning unscheduled treatment plans into booked appointments and revenue." demoScenario={agentDemoScenarios.kim} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><KimCaseAcceptanceSlide /></CarouselItem>

                    {/* ELISE */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Elise" role="Patient Experience Coordinator" image="/assets/elise.png" subtitle="Ensuring every patient feels heard and turning happy visits into 5-star reviews." demoScenario={agentDemoScenarios.elise} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><ElisePatientExperienceSlide /></CarouselItem>

                    {/* MORGAN */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Morgan" role="Patient Intake Specialist" image="/assets/morgan.png" subtitle="Ensures patients complete intake forms and provide insurance info before they arrive." demoScenario={agentDemoScenarios.morgan} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><MorganPatientIntakeSlide /></CarouselItem>

                    {/* TRISHA */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Trisha" role="AI Practice Manager" image="/assets/trisha.png" subtitle="Monitors your entire AI workforce and assigns human follow-up only when necessary." demoScenario={agentDemoScenarios.trisha} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><PracticeManagerSlide /></CarouselItem>

                    {/* COMMUNICATION SUITE */}
                    <CarouselItem className="h-full pl-0"><CommunicationTitleSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><VoIPSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><NextGenFormsSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><CommunicationSuiteSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><EFAXSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><SMSCampaignsSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><EmailCampaignsSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PhysicalPhonesSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><TextToPaySlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><CardReadersSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><TeamChatSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><OnlineSchedulingSlide /></CarouselItem>

                    {/* REVENUE CYCLE AI TEAM */}
                    <CarouselItem className="h-full pl-0">
                      <PMSTeamIntro2Slide
                        onAgentClick={(slug) => {
                          if (slug) {
                            const slideIndex = osSlides.findIndex((s) => s.slug === slug);
                            if (slideIndex !== -1) {
                              api?.scrollTo(slideIndex);
                            }
                          }
                        }}
                      />
                    </CarouselItem>

                    {/* AMANDA */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Amanda" role="Insurance Verification Specialist" image="/assets/amanda.png" subtitle="The only AI that performs dual-source insurance verification to get you more accurate and comprehensive benefits breakdowns." demoScenario={agentDemoScenarios.amanda} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><InsuranceVerificationSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><ComprehensiveBreakdownsSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0">
                      <InsuranceCopilotSlide isActive={current === (osSlides.findIndex(s => s.slug === "amanda-copilot") + 1)} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><BenefitFormsSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><InsuranceCallingSlide /></CarouselItem>

                    {/* ARIEL */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Ariel" role="AI Claims Expert" image="/assets/ariel.png" subtitle="Submitting clean claims with perfect clinical documentation instantly." theme="dark" demoScenario={agentDemoScenarios.ariel} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><ArielSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><AlainaSlide /></CarouselItem>

                    {/* ALISHA */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Alisha" role="EOB Posting Specialist" image="/assets/alisha.png" subtitle="Posts explanation of benefits and insurance payments automatically." theme="dark" demoScenario={agentDemoScenarios.alisha} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><EOBProcessingSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PaymentReconciliationSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><EOBStreamliningSlide /></CarouselItem>

                    {/* KIANNA */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Kianna" role="Patient Billing" image="/assets/kianna.png" subtitle="Uses intelligent voice AI campaigns to help patients pay their balances." theme="dark" demoScenario={agentDemoScenarios.kianna} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><PatientBillingSlide /></CarouselItem>

                    {/* SARAH - DENIAL MANAGEMENT */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide
                        name="Sarah"
                        role="Denial Management Specialist"
                        image="/assets/sarah.png"
                        subtitle="Analyzes denied claims with multi-step AI reasoning and generates appeals, corrected claims, or write-offs with one tap."
                        theme="dark"
                        demoScenario={agentDemoScenarios.sarah}
                      />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><DenialManagementSlide /></CarouselItem>

                    {/* HUMAN BILLER */}

                    {/* PRICING SECTION TITLE */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-slate-900 flex flex-col items-center justify-center text-white p-8">
                        <div className="text-center space-y-6 max-w-4xl">
                           <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-emerald-500/10 text-emerald-500 mb-4 border border-emerald-500/20">
                             <span className="text-4xl font-bold">$</span>
                           </div>
                           <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
                             Pricing & <span className="text-emerald-400">Packaging</span>
                           </h1>
                           <p className="text-xl md:text-2xl text-slate-400 max-w-2xl mx-auto">
                             Simple, transparent pricing for your AI workforce.
                           </p>
                        </div>
                      </div>
                    </CarouselItem>

                    {/* PRICING SLIDES */}

                    {/* ASHA AI OPERATING SYSTEM */}
                    <CarouselItem className="h-full pl-0">
                      <AIOSEmphasisSlide onNavigate={(slug) => {
                        const idx = osSlides.findIndex(s => s.slug === slug);
                        if (idx !== -1) api?.scrollTo(idx);
                      }} />
                    </CarouselItem>

                    {/* TOTAL COST CALCULATOR */}
                    <CarouselItem className="h-full pl-0"><TotalCostCalculatorSlide /></CarouselItem>

                    {/* PRICING */}
                    <CarouselItem className="h-full pl-0"><EngagementModelsV3Slide /></CarouselItem>

                    {/* PRICING COMPARISON — eAssist/Wisdom vs Asha */}
                    <CarouselItem className="h-full pl-0"><PricingComparisonV3Slide /></CarouselItem>

                    {/* ROI CALCULATOR */}
                    <CarouselItem className="h-full pl-0"><ROICalculatorSlide /></CarouselItem>

                    <CarouselItem className="h-full pl-0"><AshaBasicallyFreeSlide /></CarouselItem>

                    {/* RCM PRICING COMPARISON — removed */}

                    {/* AI INNOVATION FELLOWS SECTION TITLE */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full flex flex-row">
                        <div className="w-1/2 bg-slate-900 text-white flex flex-col justify-center p-20 relative overflow-hidden">
                          <div className="absolute top-0 left-0 w-64 h-64 bg-blue-500 rounded-full blur-3xl opacity-20 -translate-x-1/2 -translate-y-1/2" />
                          <div className="relative z-10">
                            <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-blue-500/10 text-blue-400 mb-6 border border-blue-500/20">
                              <Star className="w-10 h-10" />
                            </div>
                            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6">
                              AI Innovation <span className="text-blue-400">Fellows</span>
                            </h1>
                            <p className="text-xl md:text-2xl text-slate-400 max-w-2xl leading-relaxed">
                              For ambitious physicians who want to establish themselves as thought leaders for AI in dentistry.
                            </p>
                          </div>
                        </div>
                        <div className="w-1/2 bg-slate-100 relative h-full">
                          <img
                            src="/assets/dentist.jpg"
                            alt="Innovation Fellows"
                            className="w-full h-full object-cover object-center"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent flex items-end p-12">
                            <div className="text-white">
                              <p className="font-medium text-xl mb-2 flex items-center gap-2">
                                <Sparkles className="w-5 h-5 text-blue-400" />
                                Shaping the future of clinical AI
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0"><FellowsIntroSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><FellowsPartnerPerksSlide /></CarouselItem>

                    {/* GETTING STARTED SECTION TITLE */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-slate-900 flex flex-col items-center justify-center text-white p-8">
                        <div className="text-center space-y-6 max-w-4xl">
                           <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-blue-500/10 text-blue-500 mb-4 border border-blue-500/20">
                             <Sparkles className="w-10 h-10" />
                           </div>
                           <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
                             Getting <span className="text-blue-400">Started</span>
                           </h1>
                           <p className="text-xl md:text-2xl text-slate-400 max-w-2xl mx-auto">
                             Simple steps to transform your practice today.
                           </p>
                        </div>
                      </div>
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0"><GoLiveTimelineSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><DataMigrationSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><ContractTermsSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><WhiteGloveOnboardingSlide /></CarouselItem>

                    {/* FAQ SECTION TITLE */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-slate-900 flex flex-col items-center justify-center text-white p-8">
                        <div className="text-center space-y-6 max-w-4xl">
                           <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-blue-500/10 text-blue-500 mb-4 border border-blue-500/20">
                             <Sparkles className="w-10 h-10" />
                           </div>
                           <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
                             Common <span className="text-blue-400">Questions</span>
                           </h1>
                           <p className="text-xl md:text-2xl text-slate-400 max-w-2xl mx-auto">
                             Everything you need to know about partnering with Asha.
                           </p>
                        </div>
                      </div>
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0"><FAQSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><AICreditFAQSlide /></CarouselItem>

                    {/* ROI SECTION */}
                    <CarouselItem className="h-full pl-0"><ROIIntroSlide /></CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <CaseStudySlide
                        title="How Asha automated staff tasks for"
                        titleHighlight="Dental Art Care"
                        imageType="logo"
                        image="/assets/practicelogos/dentalartcare.png"
                        stats={[
                          { label: "Total ROI", value: "$25,569" },
                          { label: "Production Increase", value: "$23,400" },
                          { label: "Tasks Completed", value: "1,428" },
                        ]}
                        description="In just a few weeks, Asha's AI team booked 16 new patients and 36 appointments for existing patients — capturing opportunities that would have been missed after hours. Our insurance agent completed 506 verifications and handled 62 calls, saving the team 668 minutes on the phone. Meanwhile, AI Fax Manager automatically categorized 54 incoming faxes, freeing up staff to focus on patient care."
                        roiCards={[
                          { label: "Total ROI", value: "$25,569", subtext: "production + labor savings" },
                          { label: "New Patients Booked", value: "16", subtext: "captured automatically" },
                          { label: "Staff Hours Saved", value: "11+", subtext: "from insurance calls alone" },
                          { label: "Existing Appts Booked", value: "36", subtext: "without staff involvement" },
                        ]}
                      />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <CaseStudySlide
                        title="How Asha drove $65K in ROI for"
                        titleHighlight="Generational Dental Associates"
                        imageType="logo"
                        image="/assets/practiceimages/generational.png"
                        stats={[
                          { label: "Total ROI", value: "$65,040" },
                          { label: "Production Increase", value: "$45,950" },
                          { label: "Tasks Completed", value: "9,562" },
                        ]}
                        description="In a few months, Asha's AI Receptionist secured 23 new patients and booked 63 appointments for existing patients, including after-hours opportunities. The AI Insurance Verification agent ran 5,665 verifications and made 713 calls, saving the team 6,870 minutes on insurance calls. The AI Hygiene Recall agent booked 38 hygiene appointments and completed 865 outreach communications — all without staff intervention."
                        roiCards={[
                          { label: "Total ROI", value: "$65,040", subtext: "comprehensive impact" },
                          { label: "Verifications Run", value: "5,665", subtext: "fully automated" },
                          { label: "Staff Minutes Saved", value: "6,870", subtext: "from insurance calls" },
                          { label: "New Patients Booked", value: "23", subtext: "captured automatically" },
                        ]}
                      />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <CaseStudySlide
                        title="How Asha powered patient growth for"
                        titleHighlight="Marquette Dentistry"
                        imageType="logo"
                        image="/assets/practiceimages/marquette.png"
                        stats={[
                          { label: "Total ROI", value: "$72,798" },
                          { label: "Production Increase", value: "$66,350" },
                          { label: "Tasks Completed", value: "5,085" },
                        ]}
                        description="In a few months, Asha's AI Receptionist booked 49 new patients and handled 386 calls — including capturing after-hours opportunities that would have otherwise been missed. The AI Hygiene Recall agent secured 28 hygiene appointments and completed 2,634 communications, driving ongoing patient engagement without requiring any staff phone calls. The AI Insurance Verification agent completed 391 verifications, saving the team 236 minutes on insurance calls."
                        roiCards={[
                          { label: "Total ROI", value: "$72,798", subtext: "comprehensive impact" },
                          { label: "New Patients Booked", value: "49", subtext: "captured automatically" },
                          { label: "Hygiene Comms", value: "2,634", subtext: "automated outreach" },
                          { label: "Calls Handled", value: "386", subtext: "by AI receptionist" },
                        ]}
                      />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <CaseStudySlide
                        title="How Asha fueled growth for"
                        titleHighlight="Clovis Family Dentistry"
                        imageType="logo"
                        image="/assets/practicelogos/clovis.png"
                        stats={[
                          { label: "Total ROI", value: "$75,307" },
                          { label: "Production Increase", value: "$71,250" },
                          { label: "Tasks Completed", value: "2,642" },
                        ]}
                        description="In a few months, Asha's AI Receptionist captured 45 new patients and booked 107 appointments for existing patients — including many after-hours calls that would have gone unanswered. The AI also managed 910 patient calls, while the Hygiene Recall agent secured 16 appointments and completed 746 patient communications, keeping Clovis productive around the clock."
                        roiCards={[
                          { label: "Total ROI", value: "$75,307", subtext: "comprehensive impact" },
                          { label: "Production Increase", value: "$71,250", subtext: "from new & existing appts" },
                          { label: "New Patients", value: "45", subtext: "automatically booked" },
                          { label: "Calls Handled", value: "910", subtext: "by AI receptionist" },
                        ]}
                      />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <CaseStudySlide
                        title="How Asha streamlined operations for"
                        titleHighlight="Dentures & Dentistry Spokane"
                        imageType="logo"
                        image="/assets/practicelogos/ddsspokane.png"
                        stats={[
                          { label: "Total ROI", value: "$14,766" },
                          { label: "Production Increase", value: "$13,250" },
                          { label: "Tasks Completed", value: "1,035" },
                        ]}
                        description="In a few months, Asha's AI Receptionist booked 10 new patients and 17 appointments for existing patients, expanding access to care. The Insurance Verification agent processed 494 verifications and uploaded 240 benefits forms automatically — streamlining administrative workflows and enabling staff to focus on patient care."
                        roiCards={[
                          { label: "Total ROI", value: "$14,766", subtext: "production + labor savings" },
                          { label: "Benefits Forms Uploaded", value: "240", subtext: "fully automated" },
                          { label: "Verifications Processed", value: "494", subtext: "without staff effort" },
                          { label: "Additional Services Booked", value: "27", subtext: "new + existing patients" },
                        ]}
                      />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <CaseStudySlide
                        title="How Asha powered massive growth for"
                        titleHighlight="St. Charles Family Dentistry"
                        imageType="logo"
                        image="/assets/practicelogos/stcharles.png"
                        stats={[
                          { label: "Total ROI", value: "$188,663" },
                          { label: "Production Increase", value: "$183,850" },
                          { label: "Tasks Completed", value: "2,668" },
                        ]}
                        description="In a few months, Asha's AI Receptionist captured 204 new patients, ensuring every opportunity — including after-hours calls — was secured. The Insurance Verification agent processed 1,529 verifications, freeing up valuable staff time for patient care."
                        roiCards={[
                          { label: "Total ROI", value: "$188,663", subtext: "comprehensive impact" },
                          { label: "Production Increase", value: "$183,850", subtext: "from booked appointments" },
                          { label: "New Patients Captured", value: "204", subtext: "including after-hours" },
                          { label: "Verifications Completed", value: "1,529", subtext: "zero staff involvement" },
                        ]}
                      />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <CaseStudySlide
                        title="How Asha's AI team delivered results for"
                        titleHighlight="Premier Dentistry"
                        imageType="logo"
                        image="/assets/practicelogos/premier.png"
                        stats={[
                          { label: "Total ROI", value: "$50,650" },
                          { label: "Production Increase", value: "$44,000" },
                          { label: "Tasks Completed", value: "3,686" },
                        ]}
                        description="In a few months, Asha's AI Receptionist captured 30 new patients and booked 68 appointments for existing patients, handling 154 inbound calls — many answered outside regular office hours."
                        roiCards={[
                          { label: "Total ROI", value: "$50,650", subtext: "production + labor savings" },
                          { label: "Production Increase", value: "$44,000", subtext: "from booked appointments" },
                          { label: "Staff Phone Time Saved", value: "795 min", subtext: "from automated insurance calls" },
                          { label: "Patient Comms Automated", value: "742", subtext: "recalls & follow-ups" },
                        ]}
                      />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <CaseStudySlide
                        title="How Asha hit the ground running for"
                        titleHighlight="Dental Arts of Hudson Valley"
                        imageType="portrait"
                        image="/assets/practicelogos/hudsonvalley.png"
                        stats={[
                          { label: "Tasks Completed", value: "970+" },
                          { label: "Verifications Run", value: "542" },
                          { label: "Comms Completed", value: "629" },
                        ]}
                        description="In just a few weeks, Asha's AI Insurance Verification agent processed 542 verifications and handled 76 insurance calls, saving 861 minutes of staff phone time."
                        roiCards={[
                          { label: "Staff Minutes Saved", value: "861", subtext: "from insurance calls" },
                          { label: "Insurance Calls Automated", value: "76", subtext: "fully automated" },
                          { label: "Schedule Confirmations", value: "48", subtext: "secured automatically" },
                          { label: "Recall Comms Sent", value: "283", subtext: "keeping patients engaged" },
                        ]}
                      />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <CaseStudySlide
                        title="How Asha transformed"
                        titleHighlight="NTX Mental Health"
                        image="/assets/casestudyimage2.png"
                        stats={[
                          { label: "EHR", value: "PracticeQ" },
                          { label: "Num Providers", value: "20+" },
                          { label: "Specialties", value: "Psychiatry, Therapy, Mental Health" },
                        ]}
                        description="Asha developed a full team of AI agents hyper-specialized for NTX's practice: AI receptionist, AI patient intake agent, AI scribe, AI SMS agent, AI schedule optimizer, AI patient experience agent, AI insurance verification agent, and more."
                        roiCards={[
                          { label: "Calls fully automated", value: "67%", subtext: "no human intervention" },
                          { label: "Note-taking time eliminated", value: "82%", subtext: "with our AI scribe" },
                        ]}
                      />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0"><RealROISlide /></CarouselItem>
                  </CarouselContent>
                </div>
              </Carousel>
            </div>
          </div>

          <Button
            variant="outline"
            size="icon"
            className="absolute -left-6 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 border-0 text-slate-800 hover:text-slate-900 h-12 w-12 rounded-full backdrop-blur-sm shadow-sm z-50 disabled:opacity-50"
            onClick={() => api?.scrollPrev()}
            disabled={!api || current <= 1}
          >
            <ArrowLeft className="h-6 w-6" />
            <span className="sr-only">Previous slide</span>
          </Button>

          <Button
            variant="outline"
            size="icon"
            className="absolute -right-6 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 border-0 text-slate-800 hover:text-slate-900 h-12 w-12 rounded-full backdrop-blur-sm shadow-sm z-50 disabled:opacity-50"
            onClick={() => api?.scrollNext()}
            disabled={!api || current >= count}
          >
            <ArrowRight className="h-6 w-6" />
            <span className="sr-only">Next slide</span>
          </Button>
        </div>
      </div>
      {/* Mobile Alert */}
      <div className="fixed bottom-0 left-0 right-0 bg-blue-600/90 backdrop-blur-md text-white text-center py-3 px-4 text-xs font-semibold xl:hidden z-50 border-t border-blue-400/30 shadow-lg">
        This slideshow is designed best to be viewed on a laptop.
      </div>
    </div>
  );
};

export default OSV3SlideshowBackupPage;
